import React, { FC } from "react";

interface SelectDropdownProps {
  id: string;
  name: string;
  value: string;
  options?: { name: string; value: string }[];
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  className?: string;
  disabled?: boolean;
  children?: React.ReactNode; 
}
// A dropdown select input component with customizable options and event handling.

const SelectDropdown: FC<SelectDropdownProps> = ({
  id,
  name,
  value,
  options = [],
  onChange,
  className,
  disabled,
  children,
}) => {
  return (
    <select
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      className={className || "form-select"}
      disabled={disabled}
    >
      {children}
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.name}
        </option>
      ))}
    </select>
  );
};

export default SelectDropdown;
